module.exports = __webpack_public_path__ + "img/icon_h-clothing-store.4b1f8d58.png";